// extracted by mini-css-extract-plugin
module.exports = {"h1":"privacy_h1__3V3Yf","h2":"privacy_h2__1I658","p":"privacy_p__1ha39","b":"privacy_b__3M-OT"};